export const CONTACT_ROUTES = {
	CONTACT: "/contact",
} as const;
